// READ ME PLEASE:
//     THIS FILE IS A GENERATED. AND SHOULD BE GITIGNORED
//     YOU PROBABLY DO NOT WANT TO ALTER IT. IT'll WASTE YOUR TIME.
//     If it needs changes please set up a model that inherits and overrides
//     the behavior.

import {BaseModel} from '../Core/BaseModel';

import * as validators from '../Core/Validators';

import {
	PasswordsMatchValidator,
	RequiredValidator,
	PrimaryKeyRequiredValidator,
	PasswordRequiredValidator,
	MaxLengthValidator,
	NumericValidator,
	UnsignedNumberValidator,
} from '../Core/Validators';
import {Activity} from './Activity';
import {ContextNode} from './ContextNode';
import {ContextNodeDetails} from './ContextNodeDetails';

const _associations = [
			{
				name: 'Activity',
				model: new Activity(),
				type: 'ParentPointer',
				using: 'activityId',
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 1,
				itemTitle: 'Activity',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'ContextNode',
				model: new ContextNode(),
				type: 'ParentPointer',
				using: 'contextNodeId',
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: true,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 2,
				itemTitle: 'ContextNode',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'ContextNodeDetails',
				model: new ContextNodeDetails(),
				type: 'ParentPointer',
				using: 'contextNodeId',
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: true,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 2,
				itemTitle: 'ContextNodeDetails',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
];

const _fieldDefs = [
			{
				title: 'contextNodeActivityId',
				placeholder: null,
				key: 'contextNodeActivityId',
				isPrimaryKey: true,
				allowNull: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.contextNodeActivityId,
				setter: (x, y) => x.contextNodeActivityId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new PrimaryKeyRequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'activityId',
				placeholder: null,
				key: 'activityId',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.activityId,
				setter: (x, y) => x.activityId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'contextNodeId',
				placeholder: null,
				key: 'contextNodeId',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.contextNodeId,
				setter: (x, y) => x.contextNodeId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'created',
				placeholder: null,
				key: 'created',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.created,
				setter: (x, y) => x.created = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
					new RequiredValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'modified',
				placeholder: null,
				key: 'modified',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.modified,
				setter: (x, y) => x.modified = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'deleted',
				placeholder: null,
				key: 'deleted',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.deleted,
				setter: (x, y) => x.deleted = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
];

export class ContextNodeActivity extends BaseModel {
	constructor() {
		super();
	}

	get groupRenderers() {
		return {
		};
	}

	get recordValidators() {
		return this._recordValidators ?? ( this._recordValidators = [		]);
	}

	get associations() {
		return _associations;
	}
	get fieldDefs() {
		return _fieldDefs;
	}

}
